import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M19 0H5C2.243 0 0 2.243 0 5v10c0 2.757 2.243 5 5 5h1.44l4.087 3.44c.42.374.949.56 1.473.56.515 0 1.026-.18 1.427-.536L17.622 20H19c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5m3 15c0 1.654-1.346 3-3 3h-1.738c-.232 0-.458.081-.637.229l-4.499 3.72c-.077.069-.192.067-.289-.018l-4.388-3.696A1 1 0 0 0 6.805 18H4.999c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3zm-8.5-5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 13.5 10M9.75 8.017a3 3 0 0 0 0 3.967.999.999 0 1 1-1.499 1.324 5 5 0 0 1 0-6.615A1.001 1.001 0 0 1 9.75 8.017m6-1.324a5 5 0 0 1 0 6.615 1 1 0 0 1-1.499-1.324c1-1.131 1-2.836 0-3.967a.999.999 0 1 1 1.499-1.324m-9-1.321a7 7 0 0 0 0 9.258.999.999 0 1 1-1.499 1.324 9 9 0 0 1 0-11.906A1.001 1.001 0 0 1 6.75 5.372m12.001-1.324a9 9 0 0 1 0 11.906 1 1 0 0 1-1.499-1.324 7 7 0 0 0 0-9.258.999.999 0 1 1 1.499-1.324"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }